<template lang="pug">
  .layout-view__controls(v-if="!isConsultant")
    v-btn(
      medium
      @click="modals.showCreate = true")
      v-icon(
        position-left
        font-size="1"
        icon="plus").mr-1
      span {{ 'base.add_mixer' | translate }}
    v-dialog(
      max-width="380"
      v-model="modals.showCreate")
      create-modal(@close="modals.showCreate = false")
    v-dialog(
      max-width="380"
      :value="showEditModal"
      @input="closeMixerDetail")
      edit-modal
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import CreateModal from './modals/CreateModal'
import EditModal from './modals/EditModal'

export default {
  name: 'ControlsPanel',

  components: {
    CreateModal,
    EditModal
  },

  data: () => ({
    modals: {
      showCreate: false
    }
  }),

  methods: {
    ...mapActions('mixers', [
      'closeMixerDetail'
    ])
  },

  computed: {
    ...mapGetters('mixers', [
      'currentMixer'
    ]),

    showEditModal () {
      return this.currentMixer !== null
    }
  }
}
</script>
